// Enumerations
import { UploadIdStatesEnumeration } from 'containers/upload-id/enumerations/upload-id-states.enumeration';
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
import { UploadIdOcrStatesEnumeration } from '../enumerations/upload-id-ocr-states.enumeration';
// Types
import { WsResponseType } from 'types/ws-response.type';
import {
  UploadIdVerificationBuilderHandlersType,
  UploadIdVerificationManageListenVeridasIframeEventsHandlerType,
  UploadIdVerificationMethodsHandlersType,
  UploadIdVerificationReceiveDataBuilderHandlersType,
} from './types/upload-id-verification.handlers.type';
import {
  customerInformationNeedApproval,
  eventIsNotFromVeridas,
  isErrorType,
  isProcessCancelledCode,
  isProcessEventsCode,
  OCRDataIsSuccessfullyVerified,
} from './utils/upload-id-verification.handlers.utils';

const manageReceivedDataFromVeridasOCREventHandler = ({
  handleTrackWebSocketError,
  message,
  setCurrentState,
  setError,
  setUploadIdState,
}: UploadIdVerificationReceiveDataBuilderHandlersType): void => {
  switch (true) {
    case customerInformationNeedApproval(message): // No cuadra el OCR
      setUploadIdState(UploadIdStatesEnumeration.DIFFERENT_DATA);
      break;
    case OCRDataIsSuccessfullyVerified(message): // Ha ido bien
      setCurrentState(AppStatesEnumeration.LOADING);
      break;
    default: // Ha dado error
      handleTrackWebSocketError(message);
      setError(true);
  }
};

const manageListenVeridasIframeEventsHandler = ({
  event,
  setError,
}: UploadIdVerificationManageListenVeridasIframeEventsHandlerType): void => {
  if (eventIsNotFromVeridas(event.origin)) {
    return;
  }
  const { type, code } = event.data;

  if (isErrorType(type) || isProcessCancelledCode(code)) {
    setError(true);
  }
};

const UploadIdVerificationHandlers = (
  props: UploadIdVerificationBuilderHandlersType
): UploadIdVerificationMethodsHandlersType => ({
  handleManageReceivedDataFromVeridasOCREvent: (
    message: WsResponseType<UploadIdOcrStatesEnumeration>
  ) => manageReceivedDataFromVeridasOCREventHandler({ message, ...props }),
  handleManageListenVeridasIframeEvents: (event: MessageEvent) =>
    manageListenVeridasIframeEventsHandler({ event, setError: props.setError }),
});

export { UploadIdVerificationHandlers };
